import { combineReducers } from 'redux';
import searchResultReducer from './search-result';
import formSearchReducer from './form-search';

const taskReducer = combineReducers({
  searchResult: searchResultReducer,
  formSearch: formSearchReducer,
});

export default taskReducer;
